
import { routerMain } from 'constants/routerMain';
import React from 'react';
import { Link } from 'react-router-dom';
import {  useIntl } from 'react-intl';

export default function BreadCrumbsCustom(props) {
    const {  breadcrumbs } = props;
    const intl = useIntl();

    return (
        <nav className="p-breadcrumb p-component  background-none" aria-label="Breadcrumb" >
            <ul>
                <li
                    className= {`${breadcrumbs.length >0 ? 'pointer'  : ""} "p-breadcrumb-home"`}
                >
                    <div className={`${breadcrumbs.length <1 ? ""  : "p-menuitem-link"} text-fw-600`}  >
                        <Link
                            className="p-menuitem-text"
                            to={breadcrumbs.length >0 ? routerMain.HOME :""}
                        >
                            {' '}
                            <span className="p-menuitem-icon pi pi-home p-mr-1"></span>
                            <span>{intl.formatMessage({ id: 'home' })}</span>
                        </Link>
                    </div>
                </li>
                {breadcrumbs?.map((item, index) => (
                    <React.Fragment key={index}>
                        <li className="p-breadcrumb-chevron pi pi-chevron-right"></li>
                        {index !== breadcrumbs.length - 1 ? (
                            <li
                                className="text-fw-600 pointer"
                            >
                                <div className="p-menuitem-link">
                                    <Link className="p-menuitem-text" to={item.link}>{item.label}</Link>
                                </div>
                            </li>
                        ) : (
                            <li>
                                <span className="p-menuitem-text text-fw-600">
                                    {item.label}
                                </span>
                            </li>
                        )}
                    </React.Fragment>
                ))}
            </ul>
        </nav>
    );
}
